import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../../lib/utils";

const dropdownOptionVariants = cva(
	//base class
	"flex w-full cursor-pointer items-center justify-between border-none bg-transparent p-2 text-paragraph-3 hover:bg-neutral-1",
	{
		variants: {
			active: {
				true: "bg-neutral-1",
			},
			disabled: {
				true: "cursor-not-allowed opacity-50",
			},
		},
	}
);

export type DropDownMenuOption = {
	/**
	 * identifier
	 */
	key: string;
	/**
	 * label
	 */
	label: string;
	/**
	 * on option select
	 */
	onClick?: () => void;
	/**
	 * href for link option
	 */
	href?: string;
	/**
	 * disabled option
	 */
	disabled?: boolean;
	/**
	 * right side content, typically icon
	 */
	right?: React.ReactNode;
};

type DropDownOptionProps = {
	option: DropDownMenuOption;
	isActive: boolean;
	style?: React.CSSProperties;
	onClick?: (_key: string) => void;
};

export const DropDownOption = ({ option, isActive, style, onClick }: DropDownOptionProps) => {
	return (
		<button
			type="button"
			className={cn(dropdownOptionVariants({ active: isActive, disabled: option.disabled }))}
			style={style}
			onClick={() => onClick?.(option.key)}
			data-testid={`dropdown-option-${option.key}`}
			disabled={option.disabled}
		>
			<p className="text-left text-paragraph-3 text-neutral-9">{option.label}</p>
			{option?.right && <div className="text-paragraph-3 text-neutral-9">{option.right}</div>}
		</button>
	);
};

export const DropDownLinkOption = ({ option, isActive, style }: DropDownOptionProps) => {
	return (
		<a href={option.href ? option.href : ""} data-testid={`dropdown-option-${option.key}`} className="no-tooltip">
			<button
				type="button"
				className={cn(dropdownOptionVariants({ active: isActive, disabled: option.disabled }))}
				style={style}
				data-testid={`dropdown-option-${option.key}`}
				disabled={option.disabled}
			>
				<p className="text-left text-paragraph-3 text-neutral-9">{option.label}</p>
				<div className="text-paragraph-3 text-neutral-9">{option.right}</div>
			</button>
		</a>
	);
};
